let id = 0;
export const genId = (prefix: string) => `${prefix}-${++id}`;
